// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui'
import './assets/css/changeElement.scss'
 
import App from './App'
import api from './api/index'
import promise from 'es6-promise'
import './assets/css/style.scss'
import axios from 'axios';
import vueEsign from 'vue-esign'

Vue.use(vueEsign)
Vue.prototype.$axios = axios;

 
Vue.config.productionTip = false;

promise.polyfill()
Vue.use(ElementUI)


 
//'da670418fb3217e01e51bb5992d14f99'个人
//'da6aa8afb6472e4745e438b80568fe90',公司
Vue.prototype.HttpFn = api

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
	store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js